import { ActionType } from "actions/actions";

export const executeAction = async ({
  actionType,
  ...rest
}: {
  actionType: ActionType;
  [key: string]: any;
}) => {
  return await fetch(`/api/actions/execute-action`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ actionType, ...rest }),
  }).then((res) => res.json());
};
